




$(document).ready(function(){  

    setTimeout(function () {
      $('.label_language').html("<b>"+ $('.section-footer__lower-menu__list.desktop .language-traslateor.weglot-link--active').data('value') +"</b>");
      $("#customer_languagefooter").val($(".section-footer__lower-menu__list.desktop .language-traslateor.weglot-link--active").data("value"));
      $("#customer_language_register").val($(".section-footer__lower-menu__list.desktop .language-traslateor.weglot-link--active").data("value"));
    },500);
    $('.label_language').on('click', function (e) {
  
      if($(this).hasClass('open')){
        $(this).removeClass('open');
        $('.section-footer__lower-menu__list').slideUp();  
      }
      else{
        $(this).addClass('open');
        $('.section-footer__lower-menu__list').slideDown();  
      }
      /*
      $(this).addClass('open');
      $('.section-footer__lower-menu__list').slideDown();        
      */
  
  
    });  
    $('.language-traslateor').on('click', function (e) {   
      var new_data_val=$(this).data('value');    
  
      $('.label_language').html("<b>"+new_data_val+"</b>");
      $('.label_language').removeClass('open');
      $('.section-footer__lower-menu__list').slideUp();    
    });
  
    //main-nav_ul
    $(document).on("click",".main-nav_ul .has-children a.main-nav_link",function(e) {
        e.preventDefault();
        $('.has-children').removeClass('active');
        console.log($(this));
        $(this).parent().addClass('active');
  
    });
  });

/*------ Get Product Block Swatch ------*/
async function GetCollectionSwatch(handle, productId, isFirst) {
 // console.log("response",handle,productId,isFirst)
  fetch(`/products/${handle}.js`)
  .then(response => response.text())
  .then(async function(response){
    if(response == "" ) return;
  
    let SyncProduct = await JSON.parse(response);

     let checkDiscountTag = false;
    
    if (SyncProduct.tags.some(tag => tag.startsWith('discount_'))) {
        checkDiscountTag = true;      
    }
    
    if(SyncProduct.available ){
      let syncProductTags = SyncProduct.tags;
      let colorName = syncProductTags.find(tag => tag.includes("_color_")) ?? syncProductTags.find(tag => tag.includes("color_"));
      let swatchButtonsCount = document.querySelectorAll(`.swatch-buttons.swatch_for_${productId} .swatch-btn`).length;

        let hiddenClass = "";
        if (swatchButtonsCount >= 3) {
          hiddenClass = "hidden";
        }
      
      let swatchColorName = "";
      let altText = "";
      colorName ? swatchColorName = (colorName.split("color_"))[1] : swatchColorName = "";
      if (colorName) {
        if (colorName.includes("_color_")) {
          altText = (colorName.split("_color_"))[0];
        } else {
          altText = (colorName.split("color_"))[1];
        }
      }
      swatchColorName = swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');
      // console.log("swatchColorName",swatchColorName)
      let img_url = `https://cdn.shopify.com/s/files/1/0517/2451/7546/files/${swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-')}.png?v=1638888127`;
      let isActive = "";
      isFirst ? isActive = "swatch-active" : isActive = "";
      let swatchHTML =
          `<button type="button" data-tagExist="${checkDiscountTag}" data-price="${SyncProduct.price}" data-compare-price="${SyncProduct.compare_at_price}" data-trigger="hover" data-toggle="tooltip" data-placement="top" title="${altText.toUpperCase()}" data-title ="${SyncProduct.handle}" data-swatch-name="${swatchColorName}" class="swatch-btn ${hiddenClass} swatch-btn-image ${isActive}">
          	<img class="swatch-image lazyload" data-src="${img_url}"  src="${img_url}"/>
          	<noscript class="product-json" type="application/json">${response}<\/noscript>
          </button>`;
      // console.log(document.querySelector(`.swatch-buttons.swatch_for_${productId}`))
      document.querySelector(`.swatch-buttons.swatch_for_${productId}`).insertAdjacentHTML("beforeEnd", swatchHTML)
      if(document.querySelectorAll(`.swatch-buttons.swatch_for_${productId} button`).length > 3){
        document.querySelector(`.collection-swatch.swatch_for_${productId}`).querySelector('.plus_coor').classList.remove('hidden');
      }
      let tooltipTriggerList = [].slice.call(document.querySelector(`.collection-swatch.swatch_for_${productId}`).querySelectorAll('[data-toggle="tooltip"]'))
      let tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
      });
    }
    
    // $(".product-swatches").each(function(){
    //   var alphabeticallyOrderedDivs = $(this).find('a.swatch-btn').sort(function(a, b) {
    //     return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
    //   });
    //   $(this).append(alphabeticallyOrderedDivs);
    //   //$(this).addClass("sorted");
    // });
    $(".swatch-buttons").each(function() {
      // Sorting Swatches by Alphabetically (Color Name)
      let alphabeticallyOrderedDivs = $(this).find('button.swatch-btn').sort(function(a, b) {
        return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
      });
      $(this).append(alphabeticallyOrderedDivs);
    })

  })
  // .then(async function(response) {
  // //  console.log(typeof response.status)
  //  if(response.status === 404){
  //    return;
  //  }
  // })
.catch((error) => {
  console.warn(error)
});
}

/*------ Get Swatches On Product Page ------*/
function GetProductPageSwatch(handle,productId,isFirst, forType){
  console.log(handle,productId)
  fetch(`/products/${handle}.js`)
  .then(response => response.text())
  .then((response) => {
    let SyncProduct = JSON.parse(response);
    let syncProductTags = SyncProduct.tags;
    // console.log(syncProductTags,SyncProduct)
    if(forType == "color"){
      let colorName = syncProductTags.find(tag =>tag.includes("_color_")) ?? syncProductTags.find(tag =>tag.includes("color_"));
      let swatchColorName = "";
      let altText = "";
      // console.log(colorName)
      colorName ? swatchColorName = (colorName.split("color_"))[1] : swatchColorName = ""; 
      if(colorName){
        if(colorName.includes("_color_")){
          altText = (colorName.split("_color_"))[0];
        }else{
          altText = (colorName.split("color_"))[1];
        }
      }

      //       console.log("alt Text ",swatchColorName, altText);

      swatchColorName = swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-');

      let img_url = `https://cdn.shopify.com/s/files/1/0517/2451/7546/files/${swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-')}.png?v=1638888127`;
      let isActive = "";
      let hasUrl = "";
      isFirst ? isActive = "swatch-active" : isActive = "";
      !isFirst ? hasUrl = `/products/${SyncProduct.handle}` : hasUrl = "javascript:void(0);"; // ${theme.routes.root_url}

      let swatchHTML = 
          `<a href="${hasUrl}" class="swatch-btn swatch-btn-image ${isActive}"  data-trigger="hover" data-toggle="tooltip" data-placement="top" title="${altText.toUpperCase()}" data-title="${SyncProduct.handle}">
            <img class="swatch-image lazyload" data-src="${img_url}"  src="${img_url}"/>
            <noscript class="product-json" type="application/json">${response}</noscript>
           </a>`;
      // console.log(document.querySelector(`.product-swatch.swatch_for_${productId}`))
       if(isActive && document.querySelector('.product-swatch-color-name .js-append-active-colorName')){
        document.querySelector('.product-swatch-color-name .js-append-active-colorName').innerHTML = altText.toUpperCase();      
       } 
      document.querySelector(`.product-swatch.swatch_for_${productId}`).insertAdjacentHTML("beforeEnd",swatchHTML)

      var tooltipTriggerList = [].slice.call(document.querySelector(`.product-swatch.swatch_for_${productId}`).querySelectorAll('[data-toggle="tooltip"]'))
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {    
        return new bootstrap.Tooltip(tooltipTriggerEl)    
      });

      // Sorting Swatches by Alphabetically (Color Name)
      /*$(".product-swatches").each(function(){
        var alphabeticallyOrderedDivs = $(this).find('a.swatch-btn').sort(function(a, b) {
          return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
        });
        $(this).append(alphabeticallyOrderedDivs);
        //$(this).addClass("sorted");
      });*/
      $("[data-js-product-swatch]").each(function(){
        var alphabeticallyOrderedDivs = $(this).find('a.swatch-btn').sort(function(a, b) {
          return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
        });        
        $(this).append(alphabeticallyOrderedDivs);
        // $(this).addClass("sorted");
      });
    }
    else if(forType == "altura"){
      console.log(handle,productId,isFirst, forType);
      let currentProductHeight = syncProductTags.find(tag =>tag.includes("height_")) ?? "";
      if(!currentProductHeight.length) return;
      if(currentProductHeight.length > 0){
        currentProductHeight = currentProductHeight.split("height_")[1];
        let isActive;
        isFirst ? isActive = "active" : isActive = "variant-sold-out";

        let hasUrl = "";
        !isFirst ? hasUrl = `/products/${SyncProduct.handle}` : hasUrl = "javascript:void(0);";
        let alturaHtml = `<li> <a href="${hasUrl}" class="${isActive}" data-value="${currentProductHeight}">${currentProductHeight}</a></li>`;
        document.querySelector(`.product-altura-list.altura_for_${productId}`).querySelector(".clickyboxes").insertAdjacentHTML("beforeEnd",alturaHtml);
      } 
    }
    else{
      return;
    } 
    $(".product-altura-list li:not(.cc-hover-line)").sort(function(a, b) {
      if(a.textContent.length > b.textContent.length || a.textContent > b.textContent){
        return 1	
      }else{
        return -1;
      }

    }).appendTo('.product-altura-list .clickyboxes.altura');
  })
  .catch((err)=>{
    console.warn(err)
  });
}
